import React from 'react';

class KskdbMenu extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;
    let kskdb = hostInfo.kioskInfo.kskdb || {};
    let menuList = kskdb.menuList || [];

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kskdb.menu table</div>
        </div>

        <div style={{ paddingLeft: 20 }}>
          <div
            className='info-card pure-u-6-24'
            style={{ padding: 0, fontWeight: 400, fontSize: 14 }}
          >
            Service Type:
          </div>
          <div
            className='info-card pure-u-6-24'
            style={{ padding: 0, fontWeight: 400, fontSize: 14 }}
          >
            Name:
          </div>
          <div
            className='info-card pure-u-6-24'
            style={{ padding: 0, fontWeight: 400, fontSize: 14 }}
          >
            Start Time:
          </div>
          <div
            className='info-card pure-u-6-24'
            style={{ padding: 0, fontWeight: 400, fontSize: 14 }}
          >
            End Time:
          </div>
        </div>

        {menuList.map((menu) => {
          return (
            <div key={menu.serviceType + ' ' + menu.name} style={{ paddingLeft: 20 }}>
              <div className='info-card pure-u-6-24' style={{ padding: 0, margin: 0 }}>
                {menu.serviceType}
              </div>
              <div className='info-card pure-u-6-24' style={{ padding: 0, margin: 0 }}>
                {menu.name}
              </div>
              <div className='info-card pure-u-6-24' style={{ padding: 0, margin: 0 }}>
                {menu.startTime}
              </div>
              <div className='info-card pure-u-6-24' style={{ padding: 0, margin: 0 }}>
                {menu.endTime}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default KskdbMenu;



// WEBPACK FOOTER //
// ./src/components/KskdbMenu.js